export enum MESSAGES {
  hiddenInformationChanged = 'Hidden information changed please refresh page',
}
